import {Component, OnInit, EventEmitter} from '@angular/core';
import {firstValueFrom, map} from "rxjs";
import {FeatherModule} from "angular-feather";
import {PlotsService} from "../../services/plots.service";
import {PlotShort, PlotShortLike} from "../../model/plot";
import {UtilService} from "../../services/util.service";
import {GraphqlService} from "../../services/graphql.service";
import {FormsModule} from "@angular/forms";

import {showNotification} from '../../events';
import {StorageService} from '../../services/storage.service';
import {customerPlotsSet, selectedPlotsChange} from '../../events';

@Component({
    selector: 'app-customer-search',
    templateUrl: './customer-search.component.html',
    imports: [
    FormsModule,
    FeatherModule
],
    styleUrls: ['./customer-search.component.scss']
})
export class CustomerSearchComponent implements OnInit {
  loading = false;
  plotIDs: number[] = [];
  notFoundIDs: number[] = [];
  objectIDsString: string = '';

  filters: any = {
    id: []
  }

  constructor(
    public plotsService: PlotsService,
    private graphql: GraphqlService,
    private util: UtilService,
    private storageService: StorageService
  ) {
  }

  async ngOnInit() {
    const customerFilter = await this.storageService.get('customerFilter') as string;
    if (customerFilter) {
      this.filters = JSON.parse(customerFilter);
      this.objectIDsString = this.filters.id.join('; ');
    }
  }

  setObjectIDsString(event: any) {
    const objectIDsString = event as string;
    if (objectIDsString.match(/[\d\s;]+/)) {
      this.filters.id = objectIDsString.split(';')
        .map(objectID => Number.parseInt(objectID.trim(), 10))
        .filter(objectId => !isNaN(objectId));
      if (this.filters.id.length > 20) {
        showNotification.next({
          title: 'Fehler',
          message: 'Maximale Anzahl der Objekt-IDs ist 20.',
          class: 'is-warning'
        });
      }
    } else if (!objectIDsString.match(/^\s*$/)) {
      showNotification.next({
        title: 'Fehler',
        message: 'Objekt-IDs dürfen nur aus Zahlen bestehen. Bei der Eingabe mehrerer Objekt-IDs müssen diese durch Semikolons voneinander getrennt werden.',
        class: 'is-danger'
      });
    }
  }


  async requestPlots(all: boolean = true) {
    this.loading = true;

    // remove unused filters
    const filters: any = JSON.parse(JSON.stringify(this.filters));

    if (filters.id.length === 0) {
      delete filters.id;
    }

    let filterString = this.util.stringifyGraphQL(filters);

    const plots$ = this.graphql.queryField({
      field: 'customerFeatures', attributes: [
        'id'
      ],
      filter: filterString
    })
      .pipe(
        map((response: any) => {
          return response
            .filter((plotShortLike: any) => plotShortLike && plotShortLike.id)
            .map((plotShortLike: PlotShortLike) => new PlotShort(plotShortLike));
        })
      );

    try {
      const plots = await firstValueFrom(plots$);
      this.plotIDs = plots.map((plot: PlotShort) => plot.id);
      this.notFoundIDs = this.filters.id.filter((id: number) => !this.plotIDs.includes(id));
      console.log('received plots', plots, this.filters);
      await this.storageService.set('customerFilter', JSON.stringify(this.filters));
      customerPlotsSet.next(this.plotIDs);
      this.loading = false;
    } catch (e) {
      this.loading = false;
      const message = !!e ? e.toString() : 'Beim Laden der Schläge ist ein Fehler aufgetreten.';
      showNotification.next({title: 'Error', message, class: 'is-danger'})
    }
  }


  async resetFilters() {
    this.objectIDsString = '';
    this.filters = {
      id: [],
    }
    this.plotIDs = [];
    this.notFoundIDs = [];
    await this.storageService.remove('customerFilter');
    customerPlotsSet.next([]);
    selectedPlotsChange.next({plotIds: [], origin: 'CustomerSearchComponent'});
  }
 

  preventDefault(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

}


// 7327794; 7327804; 7327819